/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.orderStatus.internal

import features.orderStatus.models.OrderStatusResponseModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class OrderStatusServiceImpl : OrderStatusService {

    private val orderStatusRequest = OrderStatusRequest()

    override suspend fun getOrderStatus(
        overrideHeaders : Map<String, String>?,
        businessId: String    ): Result<OrderStatusResponseModel> {
        return orderStatusRequest.getOrderStatus(
            overrideHeaders = overrideHeaders,
            businessId = businessId        ).toModel()
    }
}
